import { AxiosRestApplicationClient as SettlementAxiosRestApplicationClient } from '@g2-shared/api-client/generated/settlement-app';
import {
  generateBaseAxiosClient,
  INotificationService,
  NotificationsService,
} from '@g2-shared/common';

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const SettlementApiClient = new SettlementAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);

interface DIContextInterface {
  NotificationService: () => INotificationService;
  SettlementApiClient: SettlementAxiosRestApplicationClient;
}

export const DIContext = (): DIContextInterface => ({
  SettlementApiClient,
  NotificationService: NotificationsService,
});
